import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DataComponent } from './data/data.component';
import { ReportComponent } from './report/report.component';
import { TrendingComponent } from './trending/trending.component';
import { AuthGuard } from './osc-utils/authentication/auth-guard';
import { environment } from '../environments/environment';
import { AuthFailureGuard, AuthLogoutGuard, PageLoginRedirectComponent } from '@evc/platform';
import { AuthFailedComponent } from './auth-failed/auth-failed.component';
import { LogoutComponent } from './logout/logout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/viewer',
    pathMatch: 'full',
  },
  {
    path: 'viewer',
    component: DataComponent,
    canActivate: environment.USE_CONNECT_PLATFORM ? [MsalGuard] : [AuthGuard],
  },
  {
    path: 'report',
    component: ReportComponent,
    canActivate: environment.USE_CONNECT_PLATFORM ? [MsalGuard] : [AuthGuard],
  },
  {
    path: 'trending',
    component: TrendingComponent,
    canActivate: environment.USE_CONNECT_PLATFORM ? [MsalGuard] : [AuthGuard],
  },
  {
    path: 'login',
    canActivate: [MsalGuard],
    component: PageLoginRedirectComponent,
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    component: AuthFailedComponent,
  },
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    component: LogoutComponent,
    data: { logout: true },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
